import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const baseService = createCrudService("service_codes", [], router);

export const serviceCodesService = {
  ...baseService,
  getByClient: (params) => api.getCall("/api/service_codes/by-client", params),
  listVR: () => api.getCall("/api/service_codes?payer_type=VR"),
  listDSPD: () => api.getCall("/api/service_codes?payer_type=DSPD"),
  listPP: () => api.getCall("/api/service_codes?payer_type=PP"),
  listAll: (params) => api.getCall("/api/service_codes", { include_archived: "true", ...params }),
  archive: (id) => api.putCall(`/api/service_codes/${id}/archive`),
};